var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransferCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(88.235295%,84.705883%,92.54902%)",
      fillOpacity: 1
    },
    d: "M 1.5 4.5 C 1.5 2.84375 2.84375 1.5 4.5 1.5 L 19.5 1.5 C 21.15625 1.5 22.5 2.84375 22.5 4.5 L 22.5 19.5 C 22.5 20.609375 21.898438 21.578125 21 22.097656 L 19.914062 21.75 C 19.167969 21.507812 18.355469 21.570312 17.65625 21.921875 L 16.5 22.5 L 14.25 22.5 L 12 21.375 L 9.75 22.5 L 7.5 22.5 L 6.34375 21.921875 C 5.644531 21.570312 4.832031 21.507812 4.085938 21.75 L 3 22.097656 C 2.070312 21.5625 1.5 20.570312 1.5 19.5 Z M 1.5 4.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588237%,67.450982%,73.725492%)",
      fillOpacity: 1
    },
    d: "M 7.5 8.25 L 7.5 15.75 L 1.5 15.75 L 1.5 16.5 L 7.5 16.5 L 7.5 22.5 L 8.25 22.5 L 8.25 16.5 L 15.75 16.5 L 15.75 22.5 L 16.5 22.5 L 16.5 16.5 L 22.5 16.5 L 22.5 15.75 L 16.5 15.75 L 16.5 8.25 L 22.5 8.25 L 22.5 7.5 L 16.5 7.5 L 16.5 1.5 L 15.75 1.5 L 15.75 7.5 L 8.25 7.5 L 8.25 1.5 L 7.5 1.5 L 7.5 7.5 L 1.5 7.5 L 1.5 8.25 Z M 8.25 8.25 L 15.75 8.25 L 15.75 15.75 L 8.25 15.75 Z M 8.25 8.25 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,82.352942%,41.568628%)",
      fillOpacity: 1
    },
    d: "M 4.5 22.5 L 7.5 22.5 L 7.5 7.660156 C 7.5 7.15625 7.089844 6.75 6.582031 6.75 L 3.917969 6.75 C 3.410156 6.75 3 7.15625 3 7.660156 L 3 22.097656 C 3.441406 22.355469 3.953125 22.5 4.5 22.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,3.921569%,55.29412%)",
      fillOpacity: 1
    },
    d: "M 13.332031 12.75 L 10.667969 12.75 C 10.160156 12.75 9.75 13.15625 9.75 13.660156 L 9.75 22.5 L 14.25 22.5 L 14.25 13.660156 C 14.25 13.15625 13.839844 12.75 13.332031 12.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,65.098041%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.5 22.5 L 19.5 22.5 C 20.046875 22.5 20.558594 22.355469 21 22.097656 L 21 5.40625 C 21 4.902344 20.589844 4.5 20.082031 4.5 L 17.417969 4.5 C 16.910156 4.5 16.5 4.90625 16.5 5.40625 Z M 16.5 22.5 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferCsv);
export default __webpack_public_path__ + "static/media/TransferCSV.7087399f79c7ca04104192c2d29a67ed.svg";
export { ForwardRef as ReactComponent };